import { useEffect, useState, useCallback, useRef } from "react";
// import { getDefaultLocale } from 'react-datepicker';
import { useHistory, useLocation } from "react-router-dom";

// import Google from '../../assets/icons/Google';
import { useDispatch } from "react-redux";
import InputField from "../../components/InputField/InpurField";
import { PasswordField } from "../../components/PasswordField/PasswordField";
import { actionsAuth } from "../../redux/auth.slice";
import withAuth from "../../services/withAuthProvider";
import withoutAuth from "../../services/withoutAuthProvider";
// import { setToken } from '../../services/withAuthProvider';
// import { Form, Spinner } from 'react-bootstrap';
import decodeJwtResponse from "jwt-decode";
import moment from "moment";
import toast from "react-hot-toast";
import { requestForToken, requestPermission } from "../../firebase";
import SyaratKetentuan from "../../components/Modals/SyaratKetentuan";

const initialData = {
  email: "",
  password: "",
  remember_me: false,
  is_agree: false,
  is_agree_privacy: false,
};

const CHECKBOX_STYLE = { width: "1.1rem", height: "1.1rem" };

const SignIn = () => {
  // ini adalah query params
  const { search } = useLocation();
  const queryP = new URLSearchParams(search);
  const verifyMsg = queryP.get("verifyMsg");
  const type = queryP.get("type");

  const [data, setData] = useState({ ...initialData });
  const [next, setNext] = useState(false);
  const [error, setError] = useState(null);
  const [isComponentReady, setIsComponentReady] = useState(false);
  const { push } = useHistory();
  const dispatch = useDispatch();
  const google = window?.google;

  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [isGoogleButtonReady, setIsGoogleButtonReady] = useState(false);
  const [isGoogleInitialized, setIsGoogleInitialized] = useState(false);
  const [isGoogleScriptLoaded, setIsGoogleScriptLoaded] = useState(false);
  const [showTncModal, setShowTncModal] = useState(false);
  const googleInitTimeoutRef = useRef(null);
  // const [loadingRegister, setLoadingRegister] = useState(false);

  const handleClick = (path) => {
    push(path);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Helper function untuk cleanup OTP timer yang expired
  const cleanupExpiredOtpTimer = () => {
    const resendTimeoutAt = localStorage.getItem("resendTimeoutAt");

    if (resendTimeoutAt) {
      const currentTime = moment();
      const timeoutMoment = moment(resendTimeoutAt);
      const diffSeconds = timeoutMoment.diff(currentTime, "seconds");

      // Jika sudah expired (waktu sekarang sudah lewat dari timeout)
      if (diffSeconds <= 0) {
        // Hapus sessionStorage agar saat redirect ke OTP akan request OTP baru
        sessionStorage.removeItem("otpPageVisited");
        // Hapus localStorage yang sudah expired
        localStorage.removeItem("resendTimeoutAt");
      }
    }
  };

  const handleSubmit = useCallback(
    async (e) => {
      // Prevent default form submission behavior
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      console.log("handleSubmit called", { email: data.email, hasPassword: !!data.password, isAgree: data.is_agree });

      // Cleanup timer expired sebelum submit
      cleanupExpiredOtpTimer();

      let firebaseToken = null;
      try {
        const permission = await requestPermission();
        if (permission === "granted") {
          // Tambahkan retry mechanism untuk mendapatkan token
          firebaseToken = await requestForToken();

          // Jika token masih null, coba sekali lagi setelah delay singkat
          if (!firebaseToken) {
            console.log("Token null, mencoba lagi setelah 1 detik...");
            await new Promise((resolve) => setTimeout(resolve, 1000));
            firebaseToken = await requestForToken();
          }
        }

        if (!firebaseToken) {
          console.warn("FCM token tidak tersedia, melanjutkan login tanpa token");
        }
      } catch (error) {
        console.error("Error saat mendapatkan FCM token:", error);
        // Lanjutkan login meskipun gagal mendapatkan token
      }

      if (!data.is_agree) {
        toast.error("Anda harus menyetujui terlebih dahulu syarat & ketentuan dari kami", {
          id: "error-message",
          duration: 3000,
        });
        return;
      }

      if (!data.is_agree_privacy) {
        toast.error("Anda harus menyetujui terlebih dahulu kebijakan privasi dari kami", {
          id: "error-message",
          duration: 3000,
        });
        return;
      }

      const dataLogin = {
        email: data.email,
        password: data.password,
        fcm_token: firebaseToken || null,
      };

      const response = await withoutAuth.postDataWithoutAuth("/api/login", dataLogin);
      if (response)
        if (response?.status === 200) {
          //Set token to withAuthProvider
          withAuth.setToken(response.data.data.accessToken);

          const responseUserData = await withAuth.getDataWithAuth("/api/account/user", {});
          if (responseUserData?.status === 200) {
            if (data?.remember_me) localStorage.setItem("remember_me", JSON.stringify(data.email));
            else localStorage.removeItem("remember_me");

            dispatch(
              actionsAuth.setUser({
                token: response.data.data.accessToken,
                user: responseUserData.data.data,
              })
            );
          }
        } else {
          if (
            typeof response.data.message === "object" &&
            response.data.message !== null &&
            !Array.isArray(response.data.message)
          ) {
            var data_message = "";
            for (var key in response.data.message) {
              if (response.data.message.hasOwnProperty(key)) {
                data_message += response.data.message[key];
              }
            }
            toast.error(data_message, {
              id: "error-message",
              duration: 3000,
            });
          } else {
            const otpErrorMessage = [
              "OTP tidak ditemukan",
              "Silahkan Cek Email Anda",
              "OTP tidak valid",
              "Masa berlaku OTP Anda telah habis, silakan buat OTP baru",
              "OTP sudah tidak berlaku",
            ];

            if (
              response?.status === 403 &&
              response?.data?.message === "Demi perlindungan akun Anda, silakan perbarui kata sandi Anda"
            ) {
              push("/lupa-password");
            }

            if (response?.status === 403 && otpErrorMessage.includes(response?.data?.message)) {
              // Hapus semua data OTP lama untuk memastikan request OTP baru
              localStorage.removeItem("otpExpired");
              localStorage.removeItem("resendTimeoutAt");
              sessionStorage.removeItem("otpPageVisited");

              // Redirect ke halaman OTP dengan state untuk force request OTP baru
              push("/otp", { forceNewOtp: true, email: dataLogin.email });
            }

            if (response?.status === 400 && response.data.message === "Email belum terverifikasi") {
              push("/verifikasi-akun", {
                dataParams: {
                  email: data.email,
                },
              });
            } else {
              toast.error(response.data.message, {
                id: "error-message",
                duration: 3000,
              });
            }
          }
        }
      else
        toast.error("Gagal koneksi ke server", {
          id: "error-message",
          duration: 3000,
        });
    },
    [data, dispatch, push]
  );

  const responseGoogle = useCallback(
    async (response) => {
      const responsePayload = decodeJwtResponse(response.credential);
      let firebaseToken = null;
      try {
        firebaseToken = await requestForToken();
        if (!firebaseToken) {
          console.warn("FCM token tidak tersedia untuk Google login");
        }
      } catch (error) {
        console.error("Error saat mendapatkan FCM token:", error);
      }

      const dataUser = {
        id: responsePayload.sub,
        email: responsePayload.email,
        fcm_token: firebaseToken || null,
      };

      setLoadingGoogle(true);
      const loading = toast.loading("Mengirimkan...");
      const responseAPI = await withoutAuth.postDataWithoutAuth("/api/login/social/google", dataUser);
      if (responseAPI.status === 200) {
        toast.dismiss(loading);
        toast.success(responseAPI.data.message, {
          id: "success-message",
          duration: 3000,
        });
        setLoadingGoogle(false);
        //Set token to withAuthProvider
        withAuth.setToken(responseAPI.data.data.accessToken);

        const responseUserData = await withAuth.getDataWithAuth("/api/account/user", {});
        if (responseUserData.status === 200) {
          dispatch(
            actionsAuth.setUser({
              token: responseAPI.data.data.accessToken,
              user: responseUserData.data.data,
            })
          );
        }
      } else {
        if (
          responseAPI?.status === 403 &&
          responseAPI?.data?.message === "Demi perlindungan akun Anda, silakan perbarui kata sandi Anda"
        ) {
          push("/lupa-password");
        }

        // Handle error 422 - Invalid credentials untuk Google login
        if (responseAPI?.status === 422 && responseAPI?.data?.errors?.details === "Invalid credentials.") {
          toast.dismiss(loading);
          setLoadingGoogle(false);
          toast.error("Email anda belum terdaftar, silahkan mendaftar untuk melanjutkan", {
            id: "error-message",
            duration: 3000,
          });
          push("/daftar");
          return;
        }

        toast.dismiss(loading);
        toast.error(responseAPI.data.message, {
          id: "error-message",
          duration: 3000,
        });
        setLoadingGoogle(false);
      }
      google?.accounts?.id?.disableAutoSelect();
    },
    [dispatch, google, push]
  );

  // Check if Google script is loaded
  useEffect(() => {
    const checkGoogleScript = () => {
      if (window?.google?.accounts?.id) {
        setIsGoogleScriptLoaded(true);
        return true;
      }
      return false;
    };

    // Check immediately
    if (checkGoogleScript()) {
      return;
    }

    // If not loaded, check periodically
    const intervalId = setInterval(() => {
      if (checkGoogleScript()) {
        clearInterval(intervalId);
      }
    }, 100);

    // Timeout after 10 seconds
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      if (!window?.google?.accounts?.id) {
        console.error("Google Identity Services script failed to load");
      }
    }, 10000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const emailLocal = JSON.parse(localStorage.getItem("remember_me"));
    if (emailLocal) {
      setData((prev) => ({ ...prev, email: emailLocal, remember_me: true }));
      setNext(true);
    }
    // Mark component as ready after initial setup
    setIsComponentReady(true);
  }, []);

  // Removed redundant event listeners - using onClick handlers in JSX instead

  useEffect(() => {
    // Only show toast once when component mounts with query params
    if (type !== null && verifyMsg) {
      const toastId = `verify-${type}-${verifyMsg}`;

      if (type === "success") {
        toast.success(verifyMsg.toString(), {
          id: toastId,
          duration: 3000,
        });
      } else {
        toast.error(verifyMsg.toString(), {
          id: toastId,
          duration: 3000,
        });
      }

      // Clear query params after showing toast to prevent re-showing
      if (window.history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.delete("verifyMsg");
        url.searchParams.delete("type");
        window.history.replaceState({}, "", url);
      }
    }
  }, [type, verifyMsg]);

  // Initialize Google Sign-In with hidden button - only after script is loaded
  useEffect(() => {
    // Skip if already initialized or script not loaded
    if (isGoogleInitialized || !isGoogleScriptLoaded || !google?.accounts?.id) {
      return;
    }

    // Clear any existing timeout
    if (googleInitTimeoutRef.current) {
      clearTimeout(googleInitTimeoutRef.current);
    }

    // Add a small delay to ensure DOM is ready
    googleInitTimeoutRef.current = setTimeout(() => {
      try {
        // Check again if already initialized (race condition protection)
        if (isGoogleInitialized) {
          return;
        }

        google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: responseGoogle,
        });

        // Render hidden Google button for programmatic click
        const hiddenButtonElement = document.getElementById("hiddenGoogleButton");
        if (hiddenButtonElement) {
          // Clear any existing content
          hiddenButtonElement.innerHTML = "";

          google.accounts.id.renderButton(hiddenButtonElement, {
            theme: "outline",
            size: "large",
            type: "standard",
          });

          setIsGoogleInitialized(true);
          setIsGoogleButtonReady(true);
          console.log("Google Sign-In initialized successfully");
        } else {
          console.error("Hidden button element not found");
        }
      } catch (error) {
        console.error("Error initializing Google Sign-In:", error);
        // Don't retry automatically to avoid multiple initialization attempts
      }
    }, 300);

    return () => {
      if (googleInitTimeoutRef.current) {
        clearTimeout(googleInitTimeoutRef.current);
      }
    };
  }, [isGoogleScriptLoaded, google?.accounts?.id, responseGoogle, isGoogleInitialized]);

  // Handle custom Google button click - show T&C modal first
  const handleGoogleLogin = () => {
    setShowTncModal(true);
  };

  // Triggered after user agrees to T&C in modal
  const handleConfirmTnc = () => {
    setShowTncModal(false);
    const hiddenButton = document.querySelector("#hiddenGoogleButton div[role='button']");
    if (hiddenButton) {
      hiddenButton.click();
    }
  };

  return (
    <div className="w-100" style={{ opacity: isComponentReady ? 1 : 0, transition: "opacity 0.15s ease-in" }}>
      <p className="fw-bold fs-4 mb-2">Masuk</p>
      <div className="font-sm d-flex mb-3">
        <div className="me-2 text-secondary">Belum punya akun?</div>
        <div className="text-primary cursor-pointer" onClick={() => handleClick("/daftar")}>
          Daftar
        </div>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      <div>
        <div className="mb-3">
          {next ? (
            <div className="mb-2 font-sm">
              <label>Email</label>
              <div className="d-flex fw-bold justify-content-between">
                <p className="mb-0">{data.email}</p>
                <p className="mb-0 text-primary cursor-pointer" onClick={() => setNext(false)}>
                  Ubah
                </p>
              </div>
            </div>
          ) : (
            <InputField
              id="email"
              name="email"
              placeholder="Masukan Email Anda"
              onChange={handleChange}
              label="Email"
              type="email"
              value={data.email}
              autoComplete="off"
            />
          )}
          {next ? (
            <PasswordField
              id="password"
              name="password"
              placeholder="Masukan Password Anda"
              onChange={handleChange}
              label="Password"
              value={data.password}
            />
          ) : (
            ""
          )}
          <div className="d-flex mt-2 font-sm justify-content-between">
            <div className="form-check">
              {next ? (
                <>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="disabledFieldsetCheck"
                    name="remember_me"
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.checked,
                      }))
                    }
                    checked={data.remember_me}
                    style={CHECKBOX_STYLE}
                  />
                  <label className="ms-2" htmlFor="disabledFieldsetCheck">
                    Ingat Saya
                  </label>
                </>
              ) : (
                ""
              )}
            </div>
            <p className="mb-0 fw-bold text-primary cursor-pointer" onClick={() => push("/lupa-password")}>
              Lupa Kata Sandi?
            </p>
          </div>
          {next ? (
            <>
            <div className="d-flex mt-2 font-sm justify-content-between">
              <div className="form-check" style={{ pointerEvents: "auto" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="agreeCheckbox"
                  name="is_agree"
                  onChange={(e) => {
                    console.log("Checkbox changed:", e.target.checked);
                    setData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.checked,
                    }));
                  }}
                  checked={data.is_agree}
                  style={{ ...CHECKBOX_STYLE, pointerEvents: "auto" }}
                />
                <label className="ms-2" htmlFor="agreeCheckbox" style={{ pointerEvents: "auto" }}>
                  Saya Menyetujui{" "}
                  <a
                    href="/syarat-dan-ketentuan"
                    className="fw-bold text-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ pointerEvents: "auto" }}
                  >
                    Syarat & Ketentuan
                  </a>{" "}
                  dari Caready
                </label>
              </div>
            </div>
            <div className="d-flex mt-2 font-sm justify-content-between">
              <div className="form-check" style={{ pointerEvents: "auto" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="agreePrivacyCheckbox"
                  name="is_agree_privacy"
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.checked,
                    }))
                  }
                  checked={data.is_agree_privacy}
                  style={{ ...CHECKBOX_STYLE, pointerEvents: "auto" }}
                />
                <label className="ms-2" htmlFor="agreePrivacyCheckbox" style={{ pointerEvents: "auto" }}>
                  Saya Menyetujui{" "}
                  <a
                    href="/kebijakan-privasi"
                    className="fw-bold text-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ pointerEvents: "auto" }}
                  >
                    Kebijakan Privasi
                  </a>{" "}
                  dari Caready
                </label>
              </div>
            </div>
            </>
          ) : (
            ""
          )}
        </div>
        {next ? (
          <div className="d-grid gap-2">
            <button className="btn btn-primary font-sm" type="button" onClick={handleSubmit}>
              Masuk
            </button>
          </div>
        ) : (
          <div className="d-grid gap-2">
            <button
              className="btn btn-primary font-sm"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setNext(true);
              }}
            >
              Selanjutnya
            </button>
          </div>
        )}
        <div className="text-center">
          <div className="font-sm text-secondary my-3 has-line">atau</div>
          <div className="row">
            <div className="col-md-12">
              {/* Hidden Google button for programmatic trigger */}
              <div id="hiddenGoogleButton" style={{ display: "none" }}></div>

              {/* Loading indicator when Google script is loading */}
              {!isGoogleScriptLoaded && (
                <div className="text-center text-muted font-sm py-2 mb-2">
                  <small>Memuat tombol Google...</small>
                </div>
              )}

              {/* Custom styled button */}
              <div className="d-grid gap-2 mb-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary d-flex align-items-center justify-content-center google-signin-button font-sm"
                  onClick={handleGoogleLogin}
                  onMouseDown={(e) => e.preventDefault()}
                  disabled={!isGoogleButtonReady || loadingGoogle}
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #dadce0",
                    color: "#3c4043",
                    fontWeight: 500,
                    visibility: isGoogleButtonReady ? "visible" : "hidden",
                    minHeight: "40px",
                    cursor: isGoogleButtonReady ? "pointer" : "default",
                    userSelect: "none",
                  }}
                >
                  {loadingGoogle ? (
                    <span>Loading...</span>
                  ) : (
                    <>
                      <svg width="18" height="18" viewBox="0 0 18 18" style={{ marginRight: "12px" }}>
                        <path
                          fill="#4285F4"
                          d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
                        />
                        <path
                          fill="#34A853"
                          d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
                        />
                        <path
                          fill="#FBBC05"
                          d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707 0-.593.102-1.17.282-1.709V4.958H.957C.347 6.173 0 7.548 0 9c0 1.452.348 2.827.957 4.042l3.007-2.335z"
                        />
                        <path
                          fill="#EA4335"
                          d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                        />
                      </svg>
                      Masuk dengan Google
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showTncModal && (
        <SyaratKetentuan
          onCancel={() => setShowTncModal(false)}
          onConfirm={handleConfirmTnc}
        />
      )}
    </div>
  );
};

export default SignIn;
